import { Button } from "@/components/common/Button";
import Modal from "@/components/common/Modal";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

interface Props {
  onClose?: () => void;
}

const WithdrawalError = ({ onClose }: Props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const goToMain = async () => {
    await navigate("/");
  };

  const closeModalRedirect = async () => {
    await goToMain();

    if (onClose) onClose();
  };

  return (
    <Modal title={""} onClose={closeModalRedirect}>
      <div className="w-full flex flex-col items-center p-8 gap-6">
        <div className="flex flex-col items-center gap-1 text-center">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint -tracking-[0.025rem]">
            {t("withdraw-page.error")}
          </p>
        </div>

        <Button
          onClick={closeModalRedirect}
          text={t("withdraw-page.to_main")}
          size="large"
          className="w-full"
        />
      </div>
    </Modal>
  );
};

export default WithdrawalError;
